module.exports = __webpack_public_path__ + "web-icons.71af56138b4bd557e332.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/web-icons/web-icons.eot?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.eot?v=0.2.3
// module chunks = 5